import PropTypes from 'prop-types';
import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import { TradeAccountManagerLinkLazy } from '../TradeAccountManagerLink/TradeAccountManagerLinkLazy';
import { VipAccountManagerLinkLazy } from '../VipAccountManagerLink/VipAccountManagerLinkLazy';
import SiteNav from '../SiteNav/SiteNav';

import styles from './BottomBar-style.scss';

const BottomBar = ({
    isClient,
    isUserTypeTrade,
    isUserTypeVip,
    hasUserId,
    hasRootPendingRefetch,
    navigation,
    userIds,
    viewer,
    userId,
}) => {
    const showVipAccountManagerLink = !isUserTypeTrade && isUserTypeVip;
    const linkProps = {
        isClient,
        hasRootPendingRefetch,
        hasUserId,
        userIds,
        viewer,
        userId,
    };
    return (
        <div className={styles.bar}>
            <div className={styles.barContent}>
                <div className={styles.wrapper}>
                    <SiteNav navigation={navigation} viewer={viewer} />
                    {isUserTypeTrade && <TradeAccountManagerLinkLazy {...linkProps} />}
                    {showVipAccountManagerLink && <VipAccountManagerLinkLazy {...linkProps} />}
                </div>
            </div>
        </div>
    );
};

BottomBar.propTypes = {
    navigation: PropTypes.object,
    hasRootPendingRefetch: PropTypes.bool,
    hasUserId: PropTypes.bool,
    isClient: PropTypes.bool,
    isUserTypeTrade: PropTypes.bool,
    isUserTypeVip: PropTypes.bool,
    userIds: PropTypes.array,
    viewer: PropTypes.object,
    userId: PropTypes.string,
};

const mapStateToProps = ({ header }) => {
    const { isUserTypeTrade, isUserTypeVip } = header;
    return {
        isUserTypeTrade,
        isUserTypeVip,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(BottomBar), {
    navigation: graphql`
        fragment BottomBar_navigation on Navigation {
            ...SiteNav_navigation
        }
    `,
    viewer: graphql`
        fragment BottomBar_viewer on Viewer {
            ...VipAccountManagerLink_viewer
            ...TradeAccountManagerLink_viewer
            ...SiteNav_viewer
        }
    `,
});
